import styled from 'styled-components'
import { mq } from '../../../styles/mq'

export const Container = styled.a`
  position: relative;
  display: block;
  border-bottom: none !important;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    opacity: 0;
    transition: 0.4s opacity;
    background-color: black;
  }

  &:hover::after {
    opacity: 0.3;
  }
`

export const Poster = styled.img`
  display: block;
  width: 100%;
`
export const Button = styled.span`
  position: absolute;
  top: 15px;
  left: 3%;
  display: flex;
  align-items: center;
  width: min-content;
  font-weight: bold;
  gap: 1em;
  z-index: 1;

  ${mq.medium} {
    top: 25px;
  }
`

export const PlayIcon = styled.span`
  --size: 5rem;

  ${mq.medium} {
    --size: 8rem;
  }

  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--size);
  height: var(--size);
  border-radius: 50%;
  border: 2px solid currentColor;
  flex-shrink: 0;
  transition: 0.4s background-color;

  &::before {
    content: '';
    display: block;
    margin-left: calc(var(--size) / 12);
    border: 0 solid transparent;
    border-width: calc(var(--size) / 4) 0 calc(var(--size) / 4)
      calc(var(--size) / 3);
    border-left-color: currentColor;
  }

  ${Container}:hover & {
    background-color: rgba(0 0 0 / 0.3);
  }
`
